var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialMediaT(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    fill: "#4987FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4834 18.235C36.5814 18.6356 35.6275 18.9004 34.6514 19.0212C35.6812 18.3914 36.4529 17.4006 36.8234 16.2327C35.8557 16.8224 34.7963 17.2379 33.6914 17.4611C32.9529 16.6412 31.9694 16.0955 30.8952 15.9094C29.821 15.7234 28.7169 15.9076 27.7559 16.4332C26.795 16.9587 26.0317 17.7959 25.5857 18.8134C25.1397 19.8309 25.0361 20.9711 25.2914 22.0554C23.3347 21.954 21.4207 21.4325 19.6738 20.5246C17.9268 19.6167 16.386 18.3427 15.1514 16.7855C14.7184 17.5596 14.4908 18.4362 14.4914 19.3283C14.4899 20.1567 14.6885 20.9727 15.0695 21.7035C15.4506 22.4343 16.0022 23.0574 16.6754 23.5172C15.893 23.4954 15.1273 23.2804 14.4434 22.8907V22.9521C14.4493 24.1128 14.8466 25.2358 15.5682 26.1312C16.2898 27.0265 17.2913 27.6393 18.4034 27.8657C17.9753 27.9991 17.5308 28.0694 17.0834 28.0746C16.7737 28.0709 16.4647 28.0421 16.1594 27.9886C16.4761 28.987 17.0889 29.8596 17.9127 30.4849C18.7364 31.1102 19.7301 31.457 20.7554 31.4772C19.024 32.8718 16.8865 33.6329 14.6834 33.6392C14.2823 33.6406 13.8815 33.616 13.4834 33.5655C15.7327 35.0522 18.354 35.8414 21.0314 35.8381C22.879 35.8577 24.712 35.5003 26.4231 34.7867C28.1343 34.0731 29.6894 33.0175 30.9976 31.6818C32.3059 30.346 33.341 28.7568 34.0425 27.007C34.744 25.2571 35.0978 23.3817 35.0834 21.4903V20.8392C36.025 20.1204 36.8372 19.2391 37.4834 18.235Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaT);
export default __webpack_public_path__ + "static/media/SocialMedia-t.d24e01425dd26b2b18125dc8f1dcbf12.svg";
export { ForwardRef as ReactComponent };